import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { generateUID } from '../../../helpers/uuid';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';
import { DatedValue } from 'ah-api-gateways';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxFormField',
  props: makeUseFormElementProps<FieldModel, boolean | DatedValue<boolean>>(),
  emits: makeUseFormElementEmits<boolean | DatedValue<boolean>>(),
  setup(__props, { emit }) {

const props = __props;





const uid = generateUID(6);

const formElement = useFormElement({
  emit,
  props,
});

const { fieldErrorsShown, readonly, inputErrorClass } = useBaseFieldValues(formElement);

const { modelStateRef, model, field, getSlotName, getModelState, setValue } = formElement;

const isSwitch = computed(() => getModelState('checkBoxStyle', 'checkbox') === 'switch');

const valuePropName = modelStateRef('valuePropName', 'value');

const dated = modelStateRef('dated');

const label = modelStateRef('label');

const value = computed(() => {
  if (field.value.$model && {}.hasOwnProperty.call(field.value.$model, valuePropName.value)) {
    return (field.value.$model as any)[valuePropName.value];
  }
  return field.value.$model;
});

function onChange($event: Event) {
  let value: any = !!($event.target as any).checked;
  if (dated.value) {
    value = {
      ...(typeof field.value.$model === 'object' ? field.value.$model : {}),
      [valuePropName.value]: value,
      date: new Date().toISOString(),
    };
  }
  setValue(value);
}

return { __sfc: true,props, emit, uid, formElement, fieldErrorsShown, readonly, inputErrorClass, modelStateRef, model, field, getSlotName, getModelState, setValue, isSwitch, valuePropName, dated, label, value, onChange }
}

})